
import { Component, Vue } from 'vue-property-decorator'
import { getHistoryList } from '@/api/log'
import { IArticleData } from '@/api/types'
import LineChart from '@/components/Charts/LineChart.vue'
@Component({
  name: 'Table',
  filters: {
    parseTime: (timestamp: string) => {
      let date = new Date(timestamp)
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDay()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
    }
  },
  components: {
    LineChart
  }
})
export default class extends Vue {
  private list: IArticleData[] = []
  private listLoading = true
  private dialogFormVisible = false
  private total = 0
  private dataItem = {}
  private title = '温度曲线'
  private listQuery = {
    page: 1,
    pagesize: 10,
    number: '',
    stTime: '',
    endTime: ''
  }
  created() {
    this.getList()
  }
  // 列表数据获取
  private async getList() {
    this.listLoading = true
    const { data } = await getHistoryList(this.listQuery)
    this.list = data.items
    this.total = data.total
    this.listLoading = false
  }
  // 分页切换
  private async handleCurrentChange(page:any) {
    this.listQuery.page = page
    this.getList()
  }
  // 选择编号
  private async setNumber() {
    this.listQuery.page = 1
    this.listQuery.pagesize = 10
    this.getList()
  }
  // 选择时间
  private async setStTime(time:any) {
    if (this.listQuery.endTime && time > this.listQuery.endTime) {
      this.listQuery.stTime = this.listQuery.endTime
    }
    if (this.listQuery.endTime) {
      this.listQuery.page = 1
      this.listQuery.pagesize = 10
      this.getList()
    }
  }
  private async setEndTime(time:any) {
    if (this.listQuery.stTime && time < this.listQuery.stTime) {
      this.listQuery.endTime = this.listQuery.stTime
    }
    if (this.listQuery.stTime) {
      this.listQuery.page = 1
      this.listQuery.pagesize = 10
      this.getList()
    }
  }
  // 温湿度曲线
  private async changeHandel(row:any, type:string) {
    this.dialogFormVisible = true
    if (type === 'tem') {
      this.title = '温度曲线'
      this.dataItem = {
        name: '温度',
        xAxis: ['13:00', '13:05', '13:10', '13:15', '13:20', '13:25', '13:30', '13:35', '13:40', '13:45', '13:50', '13:55'],
        data: [12, 11, 12, 15, 12, 16, 12, 22, 18, 19, 13, 15]
      }
    } else {
      this.title = '湿度曲线'
      this.dataItem = {
        name: '湿度',
        xAxis: ['13:00', '13:05', '13:10', '13:15', '13:20', '13:25', '13:30', '13:35', '13:40', '13:45', '13:50', '13:55'],
        data: [120, 110, 125, 145, 122, 165, 122, 220, 182, 191, 134, 150]
      }
    }
  }
}
